export default __webpack_public_path__ + "72e97e597eb3f49040ce5297919adf7c.png";